// 本页演示用动漫条目数据（原创示例名称，用于展示分类与版式）

export const heroAnime = {
  title: "樱花动漫在线",
  subtitle: "日漫 · 国漫 · 剧场版 · OVA，一处看懂本季值得追的番",
  description:
    "从正在更新的新番到值得回味的经典，樱花动漫在线把类型细分、观看顺序与补番路线整理成一份可以直接浏览的索引。无论你是想随手找一部下饭番，还是想系统补完一整个系列，都能在本页找到清晰的入口。",
  image:
    "https://readdy.ai/api/search-image?query=stylized%20anime%20cityscape%20at%20dusk%20with%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20soft%20pink%20and%20warm%20amber%20sky%2C%20distant%20rooftops%20and%20torii%20silhouettes%2C%20painterly%20illustration%20style%2C%20dreamy%20atmosphere%2C%20high%20detail%2C%20cinematic%20wide%20composition&width=1920&height=1080&seq=anime-hero-bg-01&orientation=landscape",
};

export const updateTicker = [
  { id: "u1", title: "星海恋歌", info: "第 12 话 · 恋爱/治愈", time: "3 分钟前" },
  { id: "u2", title: "剑舞苍穹", info: "第 08 话 · 热血/战斗", time: "18 分钟前" },
  { id: "u3", title: "食光料理屋", info: "第 05 话 · 美食/日常", time: "42 分钟前" },
  { id: "u4", title: "机械纪元 ZERO", info: "第 21 话 · 科幻/机甲", time: "1 小时前" },
  { id: "u5", title: "锦鲤侦探社", info: "第 09 话 · 悬疑/推理", time: "2 小时前" },
  { id: "u6", title: "云上九重天", info: "第 16 话 · 国漫/仙侠", time: "3 小时前" },
  { id: "u7", title: "夏日祭回忆", info: "第 04 话 · 青春/校园", time: "4 小时前" },
  { id: "u8", title: "龙语者之约", info: "第 11 话 · 奇幻/冒险", time: "5 小时前" },
];

export const featuredAnime = [
  {
    id: "f1",
    title: "星海恋歌",
    genre: "恋爱 · 治愈",
    region: "日漫",
    type: "番剧",
    episodes: 12,
    year: 2025,
    rating: 9.2,
    tags: ["新番", "高分"],
    summary:
      "天文社的少女与转学生在一场流星雨观测中相遇。作品用一整季的时间描摹两人从并肩看星星到学会开口说话的细腻过程，节奏舒缓，适合睡前一集慢慢看。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20in%20school%20uniform%20looking%20up%20at%20a%20starry%20night%20sky%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20deep%20indigo%20palette%2C%20delicate%20line%20art%2C%20romantic%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-01&orientation=portrait",
  },
  {
    id: "f2",
    title: "剑舞苍穹",
    genre: "热血 · 战斗",
    region: "日漫",
    type: "番剧",
    episodes: 24,
    year: 2025,
    rating: 8.9,
    tags: ["连载中", "燃"],
    summary:
      "少年剑客为寻找失踪的师父踏上旅途，一路结识对手与同伴。战斗作画干净利落，招式设计有记忆点，是那种每周更新都会让人想立刻点开的节奏。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20young%20swordsman%20holding%20a%20glowing%20blade%20in%20a%20windy%20bamboo%20forest%2C%20dynamic%20pose%2C%20warm%20amber%20and%20jade%20green%20palette%2C%20cinematic%20lighting%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-02&orientation=portrait",
  },
  {
    id: "f3",
    title: "云上九重天",
    genre: "仙侠 · 国漫",
    region: "国漫",
    type: "番剧",
    episodes: 20,
    year: 2025,
    rating: 8.7,
    tags: ["国漫", "仙侠"],
    summary:
      "以水墨风的云海仙门为舞台，讲述一名外门弟子靠着一手被同门看不起的旧剑法一步步闯入内门。国风美术与配乐是最大加分项，适合喜欢东方题材的观众。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20ink%20painting%20style%20anime%20key%20visual%20of%20a%20cultivator%20standing%20on%20a%20floating%20cloud%20peak%2C%20misty%20mountains%2C%20flowing%20robes%2C%20warm%20gold%20and%20soft%20pink%20accent%2C%20elegant%20minimal%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-03&orientation=portrait",
  },
  {
    id: "f4",
    title: "食光料理屋",
    genre: "美食 · 日常",
    region: "日漫",
    type: "番剧",
    episodes: 12,
    year: 2025,
    rating: 8.5,
    tags: ["下饭", "轻松"],
    summary:
      "深夜才会亮灯的街角小食堂，每集招待一位带着心事的食客，用一道家常菜换一个故事。整体基调温暖，几乎零压力，最适合吃饭时当背景。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20anime%20key%20visual%20of%20a%20small%20late%20night%20diner%20with%20warm%20lantern%20light%20and%20a%20steaming%20bowl%20of%20food%2C%20soft%20amber%20and%20cream%20palette%2C%20slice%20of%20life%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-04&orientation=portrait",
  },
  {
    id: "f5",
    title: "机械纪元 ZERO",
    genre: "科幻 · 机甲",
    region: "日漫",
    type: "番剧",
    episodes: 24,
    year: 2025,
    rating: 9.0,
    tags: ["硬核", "高分"],
    summary:
      "在被海水淹没的旧都市之上，最后的驾驶员与一台故障机甲结成搭档。机设厚重、世界观完整，前半程铺垫后进入密集对决，适合喜欢硬科幻设定的观众。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20towering%20mecha%20standing%20against%20a%20flooded%20ruined%20city%20at%20sunset%2C%20lone%20pilot%20silhouette%2C%20rust%20orange%20and%20steel%20gray%20palette%2C%20dramatic%20scale%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-05&orientation=portrait",
  },
  {
    id: "f6",
    title: "锦鲤侦探社",
    genre: "悬疑 · 推理",
    region: "日漫",
    type: "番剧",
    episodes: 13,
    year: 2024,
    rating: 8.8,
    tags: ["烧脑", "完结"],
    summary:
      "一间开在水族店后的小小侦探社，靠观察与推理解决街坊怪事。每集一案、主线暗线并行，最后一案把所有伏笔收拢，重看会有不少新发现。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20detective%20with%20a%20magnifying%20glass%20in%20a%20rainy%20neon%20lit%20alley%2C%20reflection%20of%20a%20koi%20fish%20in%20a%20puddle%2C%20teal%20and%20warm%20amber%20palette%2C%20mysterious%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-06&orientation=portrait",
  },
];

export const catalogAnime = [
  {
    id: "c1",
    title: "夏日祭回忆",
    genre: "青春 · 校园",
    region: "日漫",
    type: "番剧",
    episodes: 12,
    year: 2025,
    rating: 8.6,
    tags: ["新番", "治愈"],
    summary: "烟花大会当天走散的四名高中生，用一个夏天重新找回了彼此的联系。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20teenagers%20in%20yukata%20watching%20fireworks%20at%20a%20summer%20festival%2C%20lanterns%20and%20stalls%2C%20warm%20pink%20and%20gold%20palette%2C%20nostalgic%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-07&orientation=portrait",
  },
  {
    id: "c2",
    title: "龙语者之约",
    genre: "奇幻 · 冒险",
    region: "日漫",
    type: "番剧",
    episodes: 24,
    year: 2025,
    rating: 8.8,
    tags: ["奇幻", "连载中"],
    summary: "能听懂龙语的少年与最后一头旅龙结伴，穿越大陆寻找失落的巢穴。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20boy%20standing%20beside%20a%20majestic%20dragon%20on%20a%20grassy%20cliff%2C%20open%20sky%20and%20distant%20mountains%2C%20emerald%20and%20warm%20coral%20palette%2C%20epic%20adventure%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-08&orientation=portrait",
  },
  {
    id: "c3",
    title: "偶像光年",
    genre: "音乐 · 偶像",
    region: "日漫",
    type: "番剧",
    episodes: 13,
    year: 2025,
    rating: 8.4,
    tags: ["音乐", "励志"],
    summary: "五个性格迥异的女孩从地下小舞台开始，一场场唱到属于自己的聚光灯下。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20an%20idol%20girl%20singing%20under%20spotlights%20on%20stage%2C%20ribbons%20and%20glowing%20microphone%2C%20pink%20and%20champagne%20gold%20palette%2C%20energetic%20sparkling%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-09&orientation=portrait",
  },
  {
    id: "c4",
    title: "猫町日和",
    genre: "日常 · 治愈",
    region: "日漫",
    type: "番剧",
    episodes: 12,
    year: 2024,
    rating: 8.9,
    tags: ["治愈", "完结"],
    summary: "搬家到海边的插画师与一只自来熟的橘猫，把平凡日子过成了温柔的连载。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20an%20orange%20cat%20sitting%20on%20a%20windowsill%20in%20a%20sunny%20seaside%20room%2C%20plants%20and%20sketchbook%2C%20cream%20and%20soft%20peach%20palette%2C%20gentle%20cozy%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-10&orientation=portrait",
  },
  {
    id: "c5",
    title: "时光信箱",
    genre: "科幻 · 情感",
    region: "日漫",
    type: "番剧",
    episodes: 11,
    year: 2024,
    rating: 9.1,
    tags: ["高分", "完结"],
    summary: "一台能把信寄到过去的旧邮筒，让女孩试着改写那个没能说出口的告别。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20holding%20a%20letter%20beside%20an%20old%20post%20box%20with%20glowing%20clock%20motifs%20floating%2C%20dusk%20sky%2C%20warm%20rose%20and%20soft%20bronze%20palette%2C%20emotional%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-11&orientation=portrait",
  },
  {
    id: "c6",
    title: "青云剑宗",
    genre: "武侠 · 国漫",
    region: "国漫",
    type: "番剧",
    episodes: 26,
    year: 2025,
    rating: 8.5,
    tags: ["国漫", "武侠"],
    summary: "江湖动荡，一名药铺学徒卷入门派之争，从守着一炉药到守住一柄剑。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20wuxia%20style%20anime%20key%20visual%20of%20a%20young%20swordmaster%20leaping%20between%20misty%20bamboo%20cliffs%2C%20flowing%20sleeves%20and%20a%20silver%20blade%2C%20jade%20green%20and%20warm%20gold%20palette%2C%20elegant%20minimal%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-12&orientation=portrait",
  },
  {
    id: "c7",
    title: "极速弯道",
    genre: "运动 · 竞技",
    region: "日漫",
    type: "番剧",
    episodes: 24,
    year: 2024,
    rating: 8.3,
    tags: ["热血", "竞技"],
    summary: "一名从卡丁车场起家的少年，用一次次弯道超车闯进职业赛车的大门。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20racing%20car%20drifting%20around%20a%20mountain%20hairpin%20turn%20at%20golden%20hour%2C%20speed%20streaks%20and%20dust%2C%20warm%20orange%20and%20slate%20palette%2C%20high%20energy%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-13&orientation=portrait",
  },
  {
    id: "c8",
    title: "深海观测站",
    genre: "科幻 · 悬疑",
    region: "日漫",
    type: "番剧",
    episodes: 12,
    year: 2025,
    rating: 8.7,
    tags: ["悬疑", "新番"],
    summary: "海底观测站的六名研究员收到一段无法解释的信号，气氛一点点变得不安。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20deep%20sea%20research%20station%20glowing%20in%20dark%20water%2C%20silhouette%20of%20a%20figure%20at%20a%20porthole%2C%20teal%20and%20amber%20accent%20palette%2C%20tense%20mysterious%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-14&orientation=portrait",
  },
  {
    id: "c9",
    title: "花间茶话",
    genre: "日常 · 美食",
    region: "日漫",
    type: "番剧",
    episodes: 12,
    year: 2024,
    rating: 8.2,
    tags: ["轻松", "下饭"],
    summary: "开在花店二楼的下午茶小屋，每集用一杯手冲茶配一段客人的小故事。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20flower%20shop%20tearoom%20with%20pouring%20tea%20and%20blooming%20blossoms%2C%20pastel%20pink%20and%20cream%20palette%2C%20peaceful%20afternoon%20light%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-15&orientation=portrait",
  },
  {
    id: "c10",
    title: "墨色江山",
    genre: "历史 · 国漫",
    region: "国漫",
    type: "番剧",
    episodes: 18,
    year: 2025,
    rating: 8.6,
    tags: ["国漫", "历史"],
    summary: "以一幅长卷为线索，串起乱世中画师、将军与宫女三人交织的命运。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20historical%20anime%20key%20visual%20of%20a%20scholar%20unrolling%20a%20long%20ink%20scroll%20in%20a%20palace%20courtyard%2C%20falling%20petals%2C%20aged%20gold%20and%20deep%20rose%20palette%2C%20majestic%20minimal%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-16&orientation=portrait",
  },
  {
    id: "c11",
    title: "星轨列车",
    genre: "奇幻 · 治愈",
    region: "日漫",
    type: "番剧",
    episodes: 13,
    year: 2024,
    rating: 8.8,
    tags: ["治愈", "完结"],
    summary: "一列只在深夜运行的列车，载着有遗憾的乘客前往他们想再见一面的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20magical%20night%20train%20traveling%20through%20a%20starry%20sky%20between%20clouds%2C%20glowing%20windows%2C%20deep%20plum%20and%20warm%20gold%20palette%2C%20dreamlike%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-17&orientation=portrait",
  },
  {
    id: "c12",
    title: "街角咖啡与诗",
    genre: "文艺 · 恋爱",
    region: "日漫",
    type: "番剧",
    episodes: 12,
    year: 2025,
    rating: 8.4,
    tags: ["恋爱", "新番"],
    summary: "爱写诗的常客与总记错他点单的咖啡师，在一句句话里慢慢靠近。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20cafe%20window%20seat%20with%20a%20notebook%20of%20poems%20and%20two%20coffee%20cups%2C%20golden%20afternoon%20light%2C%20warm%20terracotta%20and%20cream%20palette%2C%20quiet%20romantic%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-18&orientation=portrait",
  },
];

export const moviesAndOva = [
  {
    id: "m1",
    title: "樱之岛·夏日终章",
    kind: "剧场版",
    region: "日漫",
    duration: "112 分钟",
    year: 2024,
    rating: 9.0,
    summary:
      "以小岛上的一个夏天为背景的独立剧场作品，画面与配乐都偏向电影质感，适合在大屏前安安静静看完。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20movie%20key%20visual%20of%20a%20lone%20figure%20on%20a%20seaside%20pier%20at%20golden%20sunset%20with%20drifting%20petals%2C%20sea%20and%20sky%20gradient%2C%20warm%20coral%20and%20soft%20pink%20palette%2C%20cinematic%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-movie-01&orientation=portrait",
  },
  {
    id: "m2",
    title: "苍穹之剑·破晓篇",
    kind: "剧场版",
    region: "日漫",
    duration: "98 分钟",
    year: 2025,
    rating: 8.7,
    summary:
      "人气战斗番的剧场版新章，聚焦主角在最终对决前的一段空白时光，战斗场面在大银幕上相当有冲击力。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20movie%20key%20visual%20of%20a%20swordsman%20facing%20a%20giant%20dawn%20sky%20with%20glowing%20blade%2C%20dramatic%20clouds%20and%20light%20rays%2C%20crimson%20and%20gold%20palette%2C%20epic%20cinematic%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-movie-02&orientation=portrait",
  },
  {
    id: "m3",
    title: "未完的信",
    kind: "OVA",
    region: "日漫",
    duration: "45 分钟",
    year: 2024,
    rating: 8.5,
    summary:
      "跟随本篇之后推出的短篇 OVA，补完了配角在故事结束后的一段日常，篇幅短但情绪很完整。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20desk%20with%20an%20unfinished%20letter%20and%20a%20soft%20lamp%2C%20cherry%20blossom%20branch%20at%20the%20window%2C%20dusty%20rose%20and%20cream%20palette%2C%20intimate%20melancholic%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-movie-03&orientation=portrait",
  },
  {
    id: "m4",
    title: "云海·外传集",
    kind: "OVA",
    region: "国漫",
    duration: "3 集 / 共 66 分钟",
    year: 2025,
    rating: 8.6,
    summary:
      "《云上九重天》的国漫外传合集，三则独立小故事分别从不同门人视角展开，画风延续正片的水墨基调。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20ink%20style%20anime%20key%20visual%20of%20three%20figures%20standing%20on%20separate%20cloud%20peaks%20above%20a%20misty%20valley%2C%20golden%20light%20and%20petals%2C%20warm%20amber%20and%20rose%20palette%2C%20serene%20elegant%20background%2C%20poster%20composition&width=600&height=840&seq=anime-movie-04&orientation=portrait",
  },
  {
    id: "m5",
    title: "机械纪元·残响",
    kind: "剧场版",
    region: "日漫",
    duration: "105 分钟",
    year: 2025,
    rating: 9.1,
    summary:
      "机甲系列的剧场版收束篇，把整条主线的谜团放在一次跨越废墟的行动中解开，信息量偏大，建议补完本篇再进。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20movie%20key%20visual%20of%20a%20damaged%20mecha%20kneeling%20in%20a%20ruined%20sunlit%20city%20with%20a%20pilot%20silhouette%2C%20smoke%20and%20light%20beams%2C%20rust%20orange%20and%20steel%20palette%2C%20cinematic%20dramatic%20mood%2C%20poster%20composition&width=600&height=840&seq=anime-movie-05&orientation=portrait",
  },
  {
    id: "m6",
    title: "猫町日和·春之篇",
    kind: "OVA",
    region: "日漫",
    duration: "38 分钟",
    year: 2025,
    rating: 8.4,
    summary:
      "治愈日常番的春日特别篇，记录了插画师与橘猫在樱花开满小城的那几天，几乎没有剧情压力。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20an%20orange%20cat%20sitting%20under%20blooming%20cherry%20trees%20on%20a%20quiet%20street%2C%20petals%20falling%2C%20pastel%20pink%20and%20cream%20palette%2C%20gentle%20spring%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-movie-06&orientation=portrait",
  },
];

export const bingeGuides = [
  {
    id: "g1",
    title: "初次入坑 · 从这四部开始",
    level: "入门",
    color: "primary",
    steps: [
      "《猫町日和》：12 集日常治愈，几乎没有门槛，先感受一下节奏。",
      "《食光料理屋》：一集一菜一故事，吃饭时间刚刚好。",
      "《夏日祭回忆》：青春群像，一季讲完一个完整的夏天。",
      "《星海恋歌》：把恋爱线拍得很克制的一部，适合作为第一部连续追的番。",
    ],
  },
  {
    id: "g2",
    title: "热血战斗 · 想一口气看到爽",
    level: "进阶",
    color: "accent",
    steps: [
      "《剑舞苍穹》：24 集，前 3 集立人物，第 4 集起进入密集对决。",
      "《机械纪元 ZERO》：世界观铺垫较长，建议两集连看。",
      "《极速弯道》：竞技节奏明快，适合当调剂。",
      "看完正片再补《苍穹之剑·破晓篇》剧场版，顺序不会乱。",
    ],
  },
  {
    id: "g3",
    title: "国漫爱好者 · 东方题材路线",
    level: "专题",
    color: "secondary",
    steps: [
      "《云上九重天》：水墨仙侠，建议先看正片 20 集。",
      "《青云剑宗》：武侠门派线，与上一部风格互补。",
      "《墨色江山》：历史长卷式叙事，适合慢慢看。",
      "最后补《云海·外传集》OVA，三则小故事补全门人视角。",
    ],
  },
  {
    id: "g4",
    title: "悬疑烧脑 · 想动动脑",
    level: "进阶",
    color: "primary",
    steps: [
      "《锦鲤侦探社》：每集一案，主线藏在细节里，别跳片头。",
      "《深海观测站》：氛围向悬疑，建议晚上关灯连看。",
      "《时光信箱》：科幻外壳下的情感故事，结局值得回味。",
      "重看《锦鲤侦探社》最后一案，会发现前面埋了很多线索。",
    ],
  },
];

export const rankingList = [
  { rank: 1, title: "星海恋歌", score: 9.2, genre: "恋爱 · 治愈", trend: "up", cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20in%20school%20uniform%20looking%20up%20at%20a%20starry%20night%20sky%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20deep%20indigo%20palette%2C%20delicate%20line%20art%2C%20romantic%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-01&orientation=portrait" },
  { rank: 2, title: "时光信箱", score: 9.1, genre: "科幻 · 情感", trend: "up", cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20holding%20a%20letter%20beside%20an%20old%20post%20box%20with%20glowing%20clock%20motifs%20floating%2C%20dusk%20sky%2C%20warm%20rose%20and%20soft%20bronze%20palette%2C%20emotional%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-11&orientation=portrait" },
  { rank: 3, title: "机械纪元·残响", score: 9.1, genre: "剧场版 · 科幻", trend: "flat", cover: "https://readdy.ai/api/search-image?query=anime%20movie%20key%20visual%20of%20a%20damaged%20mecha%20kneeling%20in%20a%20ruined%20sunlit%20city%20with%20a%20pilot%20silhouette%2C%20smoke%20and%20light%20beams%2C%20rust%20orange%20and%20steel%20palette%2C%20cinematic%20dramatic%20mood%2C%20poster%20composition&width=600&height=840&seq=anime-movie-05&orientation=portrait" },
  { rank: 4, title: "机械纪元 ZERO", score: 9.0, genre: "科幻 · 机甲", trend: "down", cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20towering%20mecha%20standing%20against%20a%20flooded%20ruined%20city%20at%20sunset%2C%20lone%20pilot%20silhouette%2C%20rust%20orange%20and%20steel%20gray%20palette%2C%20dramatic%20scale%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-05&orientation=portrait" },
  { rank: 5, title: "樱之岛·夏日终章", score: 9.0, genre: "剧场版 · 治愈", trend: "up", cover: "https://readdy.ai/api/search-image?query=anime%20movie%20key%20visual%20of%20a%20lone%20figure%20on%20a%20seaside%20pier%20at%20golden%20sunset%20with%20drifting%20petals%2C%20sea%20and%20sky%20gradient%2C%20warm%20coral%20and%20soft%20pink%20palette%2C%20cinematic%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-movie-01&orientation=portrait" },
  { rank: 6, title: "猫町日和", score: 8.9, genre: "日常 · 治愈", trend: "flat", cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20an%20orange%20cat%20sitting%20on%20a%20windowsill%20in%20a%20sunny%20seaside%20room%2C%20plants%20and%20sketchbook%2C%20cream%20and%20soft%20peach%20palette%2C%20gentle%20cozy%20atmosphere%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-10&orientation=portrait" },
  { rank: 7, title: "剑舞苍穹", score: 8.9, genre: "热血 · 战斗", trend: "up", cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20young%20swordsman%20holding%20a%20glowing%20blade%20in%20a%20windy%20bamboo%20forest%2C%20dynamic%20pose%2C%20warm%20amber%20and%20jade%20green%20palette%2C%20cinematic%20lighting%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-02&orientation=portrait" },
  { rank: 8, title: "星轨列车", score: 8.8, genre: "奇幻 · 治愈", trend: "flat", cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20magical%20night%20train%20traveling%20through%20a%20starry%20sky%20between%20clouds%2C%20glowing%20windows%2C%20deep%20plum%20and%20warm%20gold%20palette%2C%20dreamlike%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-17&orientation=portrait" },
  { rank: 9, title: "锦鲤侦探社", score: 8.8, genre: "悬疑 · 推理", trend: "down", cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20detective%20with%20a%20magnifying%20glass%20in%20a%20rainy%20neon%20lit%20alley%2C%20reflection%20of%20a%20koi%20fish%20in%20a%20puddle%2C%20teal%20and%20warm%20amber%20palette%2C%20mysterious%20mood%2C%20clean%20simple%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-06&orientation=portrait" },
  { rank: 10, title: "云上九重天", score: 8.7, genre: "仙侠 · 国漫", trend: "up", cover: "https://readdy.ai/api/search-image?query=chinese%20ink%20painting%20style%20anime%20key%20visual%20of%20a%20cultivator%20standing%20on%20a%20floating%20cloud%20peak%2C%20misty%20mountains%2C%20flowing%20robes%2C%20warm%20gold%20and%20soft%20pink%20accent%2C%20elegant%20minimal%20background%2C%20poster%20composition&width=600&height=840&seq=anime-cover-03&orientation=portrait" },
];

export const genreTabs = [
  "全部",
  "恋爱",
  "热血",
  "奇幻",
  "科幻",
  "日常治愈",
  "悬疑",
  "国漫",
];

export const faqList = [
  {
    id: "q1",
    question: "樱花动漫在线这个页面主要提供什么？",
    answer:
      "这是一个面向动漫爱好者的内容索引页，把日漫与国漫、番剧与剧场版/OVA、本季推荐与补番路线集中在一个页面上展示。你可以通过类型标签筛选感兴趣的条目，也可以直接按补番指南的顺序浏览。",
  },
  {
    id: "q2",
    question: "番剧、剧场版和 OVA 有什么区别？",
    answer:
      "番剧通常指按季度或按周连载的电视动画，篇幅多为 11–26 集；剧场版是面向影院放映的长篇动画电影，时长一般在 90 分钟以上；OVA 一般指不通过电视播出、以光盘或流媒体形式推出的短篇或番外内容，篇幅相对自由。",
  },
  {
    id: "q3",
    question: "新手应该从哪里开始补番？",
    answer:
      "建议从「补番指南」里的「初次入坑」路线开始，那四部作品篇幅适中、基调轻松，能帮你先建立追番的节奏。找到自己喜欢的类型后，再到「分类浏览」里按标签筛选，会更容易找到下一部。",
  },
  {
    id: "q4",
    question: "页面上的评分和排行榜是怎么看的？",
    answer:
      "排行榜按综合热度与口碑排序，分数是本站整理的参考分值，带有「up / down / flat」的趋势标记，方便看出近期讨论度是在上升还是趋于平稳。榜单只作浏览参考，不必当成唯一标准。",
  },
  {
    id: "q5",
    question: "国漫和日漫在浏览时会分开吗？",
    answer:
      "会。除了在分类浏览里提供「国漫」标签，我们还单独设置了「日漫与国漫」分区，用两条独立的内容线呈现各自的热门题材，方便你按喜好切换。",
  },
  {
    id: "q6",
    question: "看完正片后还需要补外传或特别篇吗？",
    answer:
      "不是必须。外传与特别篇更多是补充配角视角或延伸日常，如果你喜欢主线里的角色，补上会让体验更完整；如果只是想快速过一遍剧情，跳过也不会影响对主线的理解。",
  },
];

export const siteStats = [
  { label: "收录条目", value: "1,280+", icon: "ri-film-line" },
  { label: "类型标签", value: "36 类", icon: "ri-price-tag-3-line" },
  { label: "本季新番", value: "48 部", icon: "ri-calendar-line" },
  { label: "补番路线", value: "12 条", icon: "ri-road-map-line" },
];